export default "__VITE_ASSET__4O5L$ZVI__"